export class Provider
{
	fetch(): Promise
	{
		return new Promise();
	}
}
